import {
  Flex,
  IconButton,
  useColorModeValue,
  Input,
  InputGroup,
  InputLeftElement,
  // Select,
  Spacer,
  Box,
  Checkbox,
  Badge,
  Button,
  Switch,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
// Custom components
import { SearchIcon } from "@chakra-ui/icons";
import Select from "react-select";
import "./multiSelect.css";

import * as React from "react";
// Assets

import ModalSkus from "./ModalSkus";
import usePurchaseSupplier from "hooks/Supplier/use-purchase";
import { useHistory } from "react-router-dom";
interface BarSupplierProps {
  onSearch: (termo: string) => void;
}
// const columns = columnsDataCheck;
export const BarSupplier: React.FC<BarSupplierProps> = ({ onSearch }) => {
  const {
    suppliers,
    getSuppliers,
    isFirstData,
    paramsPurchaseOrderFilter,
    handleSwitchChange,
    idSelectDate,
    handleSelectAll,
    selectAll,
    data,
    supplierSelect,
    query,
    setQuery,
    setSupplierSect,
  } = usePurchaseSupplier();
  const customStyles = {
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: state.isSelected ? "black" : "black",
      padding: 20,
    }),
  };
  const [search, setSearch] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const novoTermo = e.target.value;
    setQuery(novoTermo);
    onSearch(query);
  };

  const searchIconColor = useColorModeValue("gray.700", "white");
  const inputBg = useColorModeValue("secondaryGray.300", "navy.900");
  const inputText = useColorModeValue("gray.700", "gray.100");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const borderCheck = useColorModeValue("gray.400", "white");
  const history = useHistory();
  const searchRef = React.useRef("");

  // React.useEffect(() => {
  //   const handleScroll = () => {
  //     const container = scrollRef.current;
  //     if (
  //       container &&
  //       container.scrollTop + container.clientHeight >=
  //         container.scrollHeight - 1 &&
  //       !loading
  //     ) {
  //       if (page <= totalPages) {
  //         page++;
  //         getData("", pageCurrent + 1, 20);
  //       }
  //     }
  //   };

  //   scrollRef.current?.addEventListener("scroll", handleScroll);
  //   return () => {
  //     scrollRef.current?.removeEventListener("scroll", handleScroll);
  //   };
  // }, [getData, loading, page, pageCurrent, totalPages]);

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
    searchRef.current = event.target.value;
  };

  React.useEffect(() => {
    if (isFirstData) {
      getSuppliers();
    }
  }, []);

  return (
    <>
      <Stack spacing={4}>
        <Flex
          direction={isMobile ? "column" : "row"}
          px="25px"
          mb="8px"
          justifyContent="space-between"
          align="center"
        >
          <Box pr={isMobile ? 20 : 4} mb={isMobile ? 4 : 0} zIndex={40}>
            <Select
              defaultValue={supplierSelect}
              name="colors"
              onChange={setSupplierSect}
              placeholder="Selecione o fornecedor..."
              options={suppliers}
              theme={(theme: { colors: any }) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  text: "#6EB680",
                  font: "#6EB680",
                  primary25: "#6EB680",
                  primary: "#6EB680",
                  neutral80: "black",
                  color: "black",
                },
              })}
              isMulti={supplierSelect === null}
              styles={customStyles}
              className="custom-select-supplier"
              classNamePrefix="select"
              zIndex={100}
            />
          </Box>

          <InputGroup w={isMobile ? "100%" : { base: "100%", md: "200px" }}>
            <InputLeftElement
              children={
                <IconButton
                  aria-label="search"
                  bg="inherit"
                  borderRadius="inherit"
                  _active={{
                    bg: "inherit",
                    transform: "none",
                    borderColor: "transparent",
                  }}
                  _focus={{
                    boxShadow: "none",
                  }}
                  icon={
                    <SearchIcon color={searchIconColor} w="15px" h="15px" />
                  }
                />
              }
            />
            <Input
              variant="search"
              fontSize="sm"
              bg={inputBg}
              color={inputText}
              fontWeight="500"
              width={isMobile ? "200px" : "400px"}
              _placeholder={{ color: "gray.400", fontSize: "14px" }}
              borderRadius={"30px"}
              placeholder={"Pesquisar"}
              onChange={handleChange}
              value={query}
            />
          </InputGroup>
          <Spacer />
          {/* <Menu /> */}
          {/* <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
        <AddUserModal />
      </Stack> */}
        </Flex>
        {supplierSelect !== null && (
          <>
            <Flex
              px="25px"
              mb="8px"
              justifyContent="space-between"
              align="center"
            >
              <Checkbox
                color="blue.600"
                borderColor={borderCheck}
                isChecked={idSelectDate.length === data.length}
                onChange={handleSelectAll}
              />
              {"\u00A0"}
              <span> Selecionar todos</span>

              <Spacer />
              {!isMobile && (
                <>
                  <ModalSkus />
                </>
              )}

              {/* <Menu /> */}
              {/* <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
        <AddUserModal />
      </Stack> */}
            </Flex>
            <Flex
              px="25px"
              mb="8px"
              justifyContent="space-between"
              align="center"
            >
              <Stack
                direction={isMobile ? "column" : "row"} // Alterna entre layout de coluna e linha
                align="start"
                px="25px"
                mb="8px"
                spacing={4} // Espaçamento entre os elementos
              >
                <div>
                  <span>Agendados</span>
                  <Switch
                    pl={4}
                    colorScheme="green"
                    size="lg"
                    isChecked={paramsPurchaseOrderFilter.scheduled}
                    onChange={() => handleSwitchChange("scheduled")}
                  />
                </div>
                <div>
                  <span>Dentro do prazo</span>
                  <Switch
                    colorScheme="yellow"
                    size="lg"
                    pl={4}
                    isChecked={paramsPurchaseOrderFilter.onTime}
                    onChange={() => handleSwitchChange("onTime")}
                  />
                </div>
                <div>
                  <span>Atrasados</span>
                  <Switch
                    colorScheme="red"
                    size="lg"
                    pl={4}
                    isChecked={paramsPurchaseOrderFilter.lated}
                    onChange={() => handleSwitchChange("lated")}
                  />
                </div>
              </Stack>
              <Spacer />
              {!isMobile && (
                <>
                  <Badge variant="subtle" colorScheme="blue" ml={2}>
                    {idSelectDate.length}
                  </Badge>
                  {"\u00A0"}
                  <span> itens selecionados</span>
                </>
              )}

              {/* <Menu /> */}
              {/* <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
        <AddUserModal />
      </Stack> */}
            </Flex>
            {isMobile && (
              <>
                <Flex
                  px="25px"
                  mb="8px"
                  justifyContent="space-between"
                  align="center"
                >
                  <ModalSkus />
                </Flex>
              </>
            )}
          </>
        )}
      </Stack>
    </>
  );
};
